<template>
    <!-- 遍历菜单列表（包裹层不占布局，避免影响 el-menu 直接子级结构） -->
    <div class="menu-wrap">
      <template v-for="item in menuList" >
        <!-- 如果有子菜单，渲染 el-submenu -->
        <el-submenu style="background-color: #2a0608;"
          v-if="item.children && item.children.length > 0"
          :index="item.path"
          :key="item.id" 
        >
          <template #title>
            <i :class="item.clazz"></i>
            <span>{{ item.label }}</span>
          </template>
          <!-- 递归调用自身，渲染子菜单 -->
          <menu-item :menu-list="item.children" @select-menu="selectMenu" />
        </el-submenu>
        <!-- 如果没有子菜单，渲染 el-menu-item -->
        <el-menu-item
          v-else
          :index="item.path"
          :key="item.id" 
          @click="selectMenu(item)"
        >
          <i :class="item.clazz"></i>
          <span>{{ item.label }}</span>
        </el-menu-item>
      </template>
    </div>
  </template>
  
  <script>
  export default {
    name: 'MenuItem',
    props: {
      menuList: {
        type: Array,
        required: true,
      },
    },
    methods: {
      // 选中菜单的回调
      selectMenu(item) {
        this.$emit('select-menu', item);
      },
    },
  };
  </script>
<style lang="less" scoped>
// 包裹层不产生布局盒子，使菜单项直接参与 el-menu 的布局，不影响其直接子级结构判断
.menu-wrap {
  display: contents;
}
// 菜单项：圆角、紧凑高度（配合侧边栏 padding 形成内缩胶囊）
.el-menu-item {
  height: 44px;
  line-height: 44px;
  margin: 4px 0;
  border-radius: 10px;
}
// 选中：品牌红渐变胶囊 + 阴影
.el-menu-item.is-active {
  background: linear-gradient(90deg, #e74405, #f2612a) !important;
  box-shadow: 0 6px 14px rgba(231, 68, 5, 0.35);
}

// 悬停：仅未选中项显示轻柔高亮；已选中（红）的项悬停不变色
.el-menu-item:hover:not(.is-active) {
  background: rgba(255, 255, 255, 0.08) !important;
}
</style>
